export const SETTLEMENT_TYPE = 'SETTLEMENT'; // Передача в заселение
export const EXPLOITATION_TYPE = 'EXPLOITATION'; // Передача в эксплуатацию
